export default class AdminNotifications {
  axiosIns = null;
  jwtConfig = null;
  rootUrl = "notifications"

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(
      `${this.rootUrl}`,
      {
        params,
      }
    );
  }

  markAsRead(id) {
    return this.axiosIns.put(
      `${this.rootUrl}/${id}`
    );
  }
}
